import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { LandingPage } from "./features/marketing/LandingPage";
import { KatzeVermisstPage } from "./features/marketing/KatzeVermisstPage";
import { VergleichPage } from "./features/marketing/VergleichPage";
import { FinderPage } from "./features/finder/FinderPage";
import { LoginPage } from "./features/auth/LoginPage";
import { SignupPage } from "./features/auth/SignupPage";
import { VerifyEmailPage } from "./features/auth/VerifyEmailPage";
import { RequestPasswordResetPage, ResetPasswordPage } from "./features/auth/PasswordResetPages";
import { AppShell } from "./features/dashboard/AppShell";
import { Dashboard } from "./features/dashboard/Dashboard";
import { CatEditPage } from "./features/cats/CatEditPage";
import { CatMessagesPage } from "./features/cats/CatMessagesPage";
import { OrderCollarsPage } from "./features/orders/OrderCollarsPage";
import { OrdersListPage } from "./features/orders/OrdersListPage";
import { OrderSuccessPage } from "./features/orders/OrderSuccessPage";
import { SmsPage } from "./features/sms/SmsPage";
import { SettingsPage } from "./features/settings/SettingsPage";
import { AdminShell } from "./features/admin/AdminShell";
import { AdminUsersPage } from "./features/admin/AdminUsersPage";
import { AdminOrdersPage } from "./features/admin/AdminOrdersPage";
import { AdminPetsPage } from "./features/admin/AdminPetsPage";
import { RequireAuth, RequireAdmin } from "./features/auth/guards";
import { ImpressumPage, DatenschutzPage, AgbPage } from "./features/legal/LegalPages";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/c/:id" element={<FinderPage />} />
        <Route path="/katze-vermisst" element={<KatzeVermisstPage />} />
        <Route path="/qr-anhaenger-vs-tasso-gps" element={<VergleichPage />} />

        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/forgot-password" element={<RequestPasswordResetPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        <Route path="/impressum" element={<ImpressumPage />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />
        <Route path="/agb" element={<AgbPage />} />

        <Route
          path="/app"
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="pets/new" element={<CatEditPage />} />
          <Route path="pets/:id" element={<CatEditPage />} />
          <Route path="pets/:id/messages" element={<CatMessagesPage />} />
          <Route path="pets/:id/order" element={<OrderCollarsPage />} />
          <Route path="orders" element={<OrdersListPage />} />
          <Route path="orders/success" element={<OrderSuccessPage />} />
          <Route path="sms" element={<SmsPage />} />
          <Route path="sms/success" element={<SmsPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminShell />
            </RequireAdmin>
          }
        >
          <Route index element={<Navigate to="orders" replace />} />
          <Route path="users" element={<AdminUsersPage />} />
          <Route path="orders" element={<AdminOrdersPage />} />
          <Route path="pets" element={<AdminPetsPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
